const o=-1;export{o as GLOBAL_START_EPOCH};
//# sourceMappingURL=constants.mjs.js.map
